@use "styles/mixins/_rem.scss" as rem;
@use "styles/mixins/_fonts.scss" as fonts;
@use "styles/mixins/_a11y.scss" as a11y;

.slider {
  accent-color: var(--color-icon-brand-primary);
  width: 100%;
  cursor: pointer;

  &[disabled] {
    appearance: none;
    border: none;
    cursor: not-allowed;
    background-color: var(--color-background-disabled);
    border-radius: var(--size-border-radius-s);
    height: rem.torem(8px);

    &::-webkit-slider-thumb {
      appearance: none;
      width: rem.torem(16px);
      height: rem.torem(16px);
      border-radius: var(--size-border-radius-l);
      background-color: var(--color-icon-disabled);
    }

    &::-moz-range-thumb {
      background-color: var(--color-background-disabled);
    }

    &::-ms-thumb {
      background-color: var(--color-background-disabled);
    }
  }
}

.slider-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: rem.torem(10px);
  margin-bottom: var(--size-spacing-m);

  .input-value {
    @include fonts.body-accent;
  }
}

.min-max-container {
  @include fonts.body-accent-xs;

  color: var(--color-text-subtle);
  display: flex;
  justify-content: space-between;
}

.visually-hidden {
  @include a11y.visually-hidden;
}
